import { useState } from 'react';
import { FileStack } from 'lucide-react';
import { DesenhoRevisoesDialog } from '../../components/desenhos/desenho-revisoes-dialog';

export interface MaterialDesenhosSectionProps {
  readonly materialId: string;
  readonly revisaoContextualId?: string | null;
}

/** Entrada real do cadastro: a lista e as mutações vivem no diálogo para manter foco e formulário do material intactos. */
export function MaterialDesenhosSection({ materialId, revisaoContextualId }: MaterialDesenhosSectionProps) {
  const [aberto, setAberto] = useState(false);
  return (
    <section className="space-y-2 border-t pt-4" aria-labelledby="material-desenhos-titulo">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div><h3 id="material-desenhos-titulo" className="text-sm font-semibold text-slate-900">Desenhos técnicos</h3><p className="text-xs text-slate-600">Revisões são imutáveis; publicar afeta somente referências futuras.</p></div>
        <button type="button" onClick={() => setAberto(true)} className="inline-flex min-h-11 items-center gap-2 rounded border border-slate-300 px-3 text-sm font-semibold text-slate-800 hover:bg-slate-50"><FileStack className="size-4" />Gerir revisões</button>
      </div>
      <DesenhoRevisoesDialog materialId={materialId} aberto={aberto} onAbertoChange={setAberto} revisaoContextualId={revisaoContextualId} />
    </section>
  );
}
